import type { CSSProperties } from 'react';

/**
 * Shared inline styles for the small chip-based multi-value inputs
 * (`TagInput`, `CityAutocompleteInput`) so their text field, label, and
 * selected-value chips stay visually identical.
 */

export const chipInputStyle: CSSProperties = {
  width: '100%',
  height: 40,
  padding: '9px 12px',
  border: '1px solid var(--border-subtle)',
  borderRadius: 'var(--radius-md)',
  background: 'var(--surface-tertiary)',
  color: 'var(--text-primary)',
  fontSize: 13,
  fontFamily: 'var(--font-family)',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.15s ease',
};

export const chipInputLabelStyle: CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  color: 'var(--text-secondary)',
  marginBottom: 6,
  display: 'block',
  fontFamily: 'var(--font-family)',
};

export const chipInputChipStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 10px',
  fontSize: 12,
  borderRadius: 'var(--radius-sm)',
  background: 'var(--surface-tertiary)',
  border: '1px solid var(--border-subtle)',
  color: 'var(--text-primary)',
  fontFamily: 'var(--font-family)',
};

export const chipInputRemoveButtonStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  padding: 0,
  color: 'var(--text-tertiary)',
  fontSize: 14,
  lineHeight: 1,
};
